"use strict";
// Cross-surface analytics identity — surfaces + super-property keys.
//
// Deps-free leaf (ADR-0005 pattern): imports nothing outside this folder, so
// every front-end (web, Photoshop/UXP, Miro/Web-SDK, future CLI) can bundle it
// without dragging the rest of `shared` along. The C# plugins (Revit, Rhino)
// can't import TS — they share a mirrored constants file guarded by a parity
// test. The Omniverse (Python) extension will mirror these the same way. See
// ADR-0016.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPER_PROPS = exports.SURFACES = void 0;
// The originating client of an event. Registered as the `surface`
// super-property on EVERY surface (web included) so one PostHog insight can
// break shared events down by client. Use `surface`, never `platform`
// (overloaded). See CONTEXT.md "Product analytics".
exports.SURFACES = {
    WEB: 'web',
    PHOTOSHOP: 'photoshop',
    MIRO: 'miro',
    REVIT: 'revit',
    RHINO: 'rhino',
    OMNIVERSE: 'omniverse',
};
// The fixed set of super-property keys shared verbatim by web and all plugins.
// Names MUST match across surfaces — a divergent key (e.g. `account_kind`)
// defeats single-insight breakdowns. `is_team_user`/`team_id` are derived
// client-side from the selected Account; the rest come from /me (ADR-0016).
exports.SUPER_PROPS = {
    SURFACE: 'surface',
    PLAN: 'plan',
    IS_TEAM_USER: 'is_team_user',
    TEAM_ID: 'team_id',
    ACCOUNT_AGE_DAYS: 'account_age_days',
    IS_INTERNAL_ADMIN: 'is_internal_admin',
};
